import React from 'react'
import { Form, InputNumber } from 'antd'
import styled from 'styled-components'
import { FormInstance } from 'antd/es/form'
import { QuestionTypeEnum } from 'packages/sdks-next/growp'
import { precisionFormat } from 'packages/utils'

export const EditScore: React.FC<{
  form: FormInstance
  type: QuestionTypeEnum
  value?: string | number
  disabled?: boolean
}> = ({ form, value, type, disabled = false }) => {
  return (
    <StyleNumberFormItem
      label="分数"
      name="score"
      rules={
        type === QuestionTypeEnum.FillInBlank
          ? []
          : [{ required: true, message: '请输入分数' }]
      }
    >
      <InputNumber
        value={precisionFormat(value)}
        style={{ width: 160 }}
        placeholder={'请输入'}
        stringMode={true}
        disabled={
          disabled ||
          [QuestionTypeEnum.FillInBlank].includes(form.getFieldValue('type'))
        }
      />
    </StyleNumberFormItem>
  )
}

const StyleNumberFormItem = styled(Form.Item)`
  &&& {
    margin-bottom: 0;
    .ant-input-number-group > .ant-input-number:first-child,
    .ant-input-number-group-addon:first-child {
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }
  }
`
